
import React from 'react';
import { Profile } from '@/hooks/useProfile';
import { User } from '@supabase/supabase-js';
import ImageUpload from './image-upload/ImageUpload';

interface ProfileFormHeaderProps {
  profile: Profile;
  user: User;
  avatarPreview: string | null;
  onAvatarChange: (url: string) => void;
  isUploading?: boolean;
}

const ProfileFormHeader = ({ 
  profile, 
  user, 
  avatarPreview, 
  onAvatarChange,
  isUploading = false
}: ProfileFormHeaderProps) => {
  // Create a handler that adapts the ImageUpload's output to the required format
  const handleImageUploaded = (url: string) => {
    onAvatarChange(url);
  };

  return (
    <div className="mb-6">
      <div className="mb-4">
        <h3 className="text-lg font-medium">Profile Photo</h3>
        <p className="text-sm text-muted-foreground mt-1">
          Upload a professional profile photo to help others recognize you
        </p>
      </div>
      
      <ImageUpload 
        user={user}
        bucketName="avatars"
        currentImageUrl={avatarPreview}
        onImageUploaded={handleImageUploaded}
        label="Profile Picture"
        buttonText="Upload Profile Picture"
        previewSize="medium"
        aspectRatio="square"
      />
    </div>
  );
};

export default ProfileFormHeader;
